import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'StarlinkTheme',
  code: 'Starlink',
  colors: {
    headerBackground: '#0D0D0D',
    headerText: '#FFFFFF',
    headerBorder: '#0D0D0D',
    background: '#FFFFFF',
    footerBackground: '#0D0D0D',
    footerText: '#FFFFFF',
    footerBorder: '#0D0D0D',
    progressBar: '#3957E1',
  },
  logoSize: {
    width: '160px',
    height: '40px',
  },
  baseColors: {
    link: '#3957E1',
    cta: '#3957E1',
    hover: '#2F48BB',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const StarlinkTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
